import { useSelector } from 'react-redux'
import { selectUserType } from '@/features/domain/user'

export function useIsCourier() {
  const userType = useSelector(selectUserType)

  return userType === 'courier'
}
